// StatusCellRenderer.tsx
import React from 'react'
import type { ICellRendererParams } from 'ag-grid-community'
import { Switch } from 'antd'

type Params = ICellRendererParams & {
    onToggle?: (id: number, nextValue: boolean) => void
    idKey?: 'id' | 'key'
    labels?: { on: string; off: string }
}

const StatusCellRenderer: React.FC<Params> = (params) => {
    const { value, data, onToggle, idKey = 'key', labels } = params
    const checked = value
    const id = Number(data?.[idKey])

    const handleChange = () => {
        if (Number.isFinite(id) && onToggle) onToggle(id, !checked)
    }

    return (
        <div className="d-flex align-center gap-10-px">
            {/* muốn đồng bộ 2 chiều thì dùng checked thay vì defaultChecked */}
            <Switch
                defaultChecked={checked}
                onChange={handleChange}
                className="rs-switch rs-switch--sm"
            />
            <span className="font-medium fw-500 text-344054">
                Đang sử dụng
                {/* {checked ? (labels?.on ?? 'Đang sử dụng') : (labels?.off ?? 'Ngừng sử dụng')} */}
            </span>
        </div>
    )
}

export default StatusCellRenderer
